import { render, staticRenderFns } from "./Onsite_service.vue?vue&type=template&id=896cdd8c"
import script from "./Onsite_service.vue?vue&type=script&lang=js"
export * from "./Onsite_service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports